module.exports = __webpack_public_path__ + "static/media/mzprocoverphoto.a9919aed.png";